import React from 'react'
import './banner.scss'
import Img from 'gatsby-image'
import Icon from '../../atoms/Icon/Icon'
import ModalShare from '../modal-share/modal-share'
import { pushDataLayerEvent } from '../../../utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../utils/userInfo'

const Banner = props => {
	const {
		image,
		title,
		tag,
		date,
		isMobile,
		autor = '',
		titleInHeader,
	} = props.info
	const { isArticle = true, likes } = props
	const [isModalActive, setModalActive] = React.useState()

	const imageBanner = isArticle
		? image[!isMobile ? 0 : 1]
		: isMobile
		? image.bannerMobile
		: image.bannerDesktop

    const userInf=dataLayerUserInfo()
    const dataLaterBanner = (label,titulo, subCat,event,action) => {
		const tipo = isArticle? 'Artículo': 'Curso'
		const sub= subCat!==''? subCat: 'ninguno'
        
		let location=''
		if (typeof window !== 'undefined') {
			location= window.location.href
		}
		pushDataLayerEvent({event: event,
		category: 'academia tena',
		action: action,
		label: label,
        article_name: titulo,
		sub_category: sub,
		location: location,
        article_type:tipo,
		user_data: userInf.user_data? userInf.user_data: '',
		log_status: userInf.log_status,})
	}
	const handleRenderInfo = () =>
		isMobile ? (
			<>
				<h1 className='f-general-banner__info__title'>{title}</h1>
				<div className='f-general-banner__info__social'>
					<button
						className='f-general-banner__info__social__btn-share'
						onClick={() => {
							setModalActive(true)
						}}
					>
						<span>Compartir</span>
						<i className='icon-share'></i>
					</button>
					<button
						className='f-general-banner__info__social__btn-share'
						onClick={likes.toogle}
					>
						<span>Me gusta</span>
						<i
							className={`icon-heart ${!likes.info?.like ? 'disabled' : ''}`}
						></i>
						{likes.info?.totalLikes || 0}
					</button>
				</div>
				<p className='f-general-banner__info__date'>
					<Icon icon='icon-calendar ' />
					{date}
				</p>
			</>
		) : (
			<>
				{!titleInHeader && (
					<h1 className='f-general-banner__info__title'>{title}</h1>
				)}
				<>
					{!isArticle ? (
						<h2 className='f-general-banner__info__subtitle'>{autor}</h2>
					) : null}
				</>
				<div className='f-general-banner__info__social'>
					<p className='f-general-banner__info__social__date'>
						<Icon icon='icon-calendar ' />
						{date}
					</p>
					<button
						className='f-general-banner__info__social__btn-share'
						onClick={() => {
							dataLaterBanner('Compartir',title, tag,'Interacciones - Articulos', 'click')
							setModalActive(true)
						}}
					>
						<span>Compartir</span>
						<i className='icon-share'></i>
					</button>
					<button
						className='f-general-banner__info__social__btn-share'
						onClick={()=>{
							dataLaterBanner('Me gusta',title, tag,'Interacciones - Articulos', 'click')
							likes.toogle()
						}}
					>
						<span>Me gusta</span>
						<i
							className={`icon-heart ${!likes.info?.like ? 'disabled' : ''}`}
						></i>
						{likes.info?.totalLikes || 0}
					</button>
				</div>
			</>
		)

	return (
		<>
			<div className='f-general-banner'>
				<div className='f-general-banner__image'>
					<div
						className={`f-general-banner-info ${
							!titleInHeader ? 'f-general-banner-info--no-title' : ''
						}`}
					>
						{tag && <span className='f-general-banner-info__tag '>{tag}</span>}

						{titleInHeader && (
							<h1 className='f-general-banner-info__title'>{title}</h1>
						)}
					</div>
					<Img
						className='f-image-banner'
						fluid={imageBanner.fluid}
						alt={imageBanner.description}
					/>
				</div>

				<div className='f-general-banner__info'>{handleRenderInfo()}</div>
			</div>
			{isModalActive && (
				<ModalShare
					hideAction={() => {
						setModalActive(false)
					}}
				/>
			)}
		</>
	)
}

export default Banner
